import { Message } from 'element-ui'
import html2canvas from "html2canvas";
// const moment = require('moment');
/*获取缓存数据*/
export function getRouteMenuData() {
  return JSON.parse(window.sessionStorage.getItem("currentRouteMenu"));
}
/*存入缓存数据*/
export function setRouteMenuData(value) {
  return window.sessionStorage.setItem("currentRouteMenu",JSON.stringify(value))
}
/*获取缓存数据*/
export function getSessionData(key) {
  return JSON.parse(window.sessionStorage.getItem(key));
}
/*存入缓存数据*/
export function setSessionData(key,value) {
  return window.sessionStorage.setItem(key,JSON.stringify(value))
}
/*删除缓存数据*/
export function deleteSessionData(key) {
  return window.sessionStorage.removeItem(key)
}
/*获取缓存token*/
export function getToken() {
  return window.sessionStorage.getItem("token")
}
/*是否有token*/
export function hasToken() {
  if(window.sessionStorage.getItem("token")){
    return true
  }else{
    return false
  }
}
/*时间戳转年月日*/
export function getTime(val,type,bar) {
  if(!val){
    return ""
  }
  let barText = bar?bar:"-";
  let timeObj = {
    "s":"YYYY-MM-DD HH:mm:ss",
    "h":"YYYY-MM-DD HH:mm",
    "y":"YYYY-MM-DD"
  }
  var date = new Date(val);
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  var seconds = date.getSeconds().toString().padStart(2, '0');
  if(type == "y"){
    return `${year}${barText}${month}${barText}${day}`
  }else if(type == "h"){
    return `${year}${barText}${month}${barText}${day} ${hours}:${minutes}`;
  }else{
    return `${year}${barText}${month}${barText}${day} ${hours}:${minutes}:${seconds}`;
  }
}
/*获取毫秒数*/
export function getSecond(val) {
  if(!val){
    return ""
  }
  return new Date(val).getTime()
}
/*公共提示*/
export function showTip(text,type,tip) {
  if(!tip){
    return
  }
  Message({
    message: text, //error.message,
    type: type,
    duration: 5 * 1000,
  });
}
/*水印*/
export function addWatermark(text,watermarkDiv) {
  // const watermarkDiv = this.$refs.watermark;
  const canvas = document.createElement('canvas');
  canvas.width = 200; // 增大 canvas 尺寸
  canvas.height = 200;

  const ctx = canvas.getContext('2d');
  ctx.rotate(-20 * Math.PI / 180);
  ctx.font = '16px Arial'; // 增大字体尺寸
  ctx.fillStyle = 'rgba(200, 200, 200, 0.3)';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, canvas.width / 2, canvas.height / 2);

  watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
  watermarkDiv.style.backgroundSize = '200px 200px'; // 设置背景图片大小，减少重复
  watermarkDiv.style.pointerEvents = 'none';
  // watermarkDiv.style.position = 'r';
  // watermarkDiv.style.top = 0;
  // watermarkDiv.style.left = 0;
  watermarkDiv.style.width = '100%';
  watermarkDiv.style.height = '100%';
  watermarkDiv.style.zIndex = 9999;
}
/*下载表格*/
export function downTable(idName,fileName){
  // tableContent
  const element = document.getElementById(idName) // 要转换成图片的DOM元素
  // const width = element.scrollWidth // 获取元素实际宽度
  // const height = element.scrollHeight // 获取元素实际高度
  // console.log(width,height)
  setTimeout(() => {
    const link = document.createElement('a')
    const canvas = html2canvas(element, {
      // width: width,
      // height: height,
      // windowWidth: width+100, // 少多少宽度补多少宽度，会少一部分数据，我自己加上了，没找到原因
      scale: 1, // 缩放比例 这个数值根据具体需求调整
      useCORS: true,
      // backgroundColor: 'transparent' // 背景区域设置透明背景色
    }).then(function (canvas) {
      const dataURL = canvas.toDataURL('image/jpeg', 1.0)
      link.setAttribute('download', fileName) // 设置下载名称
      link.href = dataURL // 转换为png格式
      link.click()
    })
  }, 1000)
}

/** 下载表格 */
export const downTableNew = (idName,fileName) => {
  return new Promise((resolve) => {
    const element = document.getElementById(idName) // 要转换成图片的DOM元素
    setTimeout(() => {
      const link = document.createElement('a')
      html2canvas(element, {
        scale: 1, // 缩放比例 这个数值根据具体需求调整
        useCORS: true,
      }).then(function (canvas) {
        const dataURL = canvas.toDataURL('image/jpeg', 1.0)
        link.setAttribute('download', fileName) // 设置下载名称
        link.href = dataURL // 转换为png格式
        link.click()
        resolve(true)
      })    
    }, 1000)
  })
}
